import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--left",
  "use": "icon-arrow--left-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 32 32\" id=\"icon-arrow--left\"><path d=\"m17.06 6.53-8.72 8.72h18.19v1.5H8.34l8.72 8.72L16 26.53 5.468 16l10.53-10.53 1.06 1.06Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol